import { render, staticRenderFns } from "./corporateImageList.vue?vue&type=template&id=21b6b790&scoped=true&"
import script from "./corporateImageList.vue?vue&type=script&lang=js&"
export * from "./corporateImageList.vue?vue&type=script&lang=js&"
import style0 from "./corporateImageList.vue?vue&type=style&index=0&id=21b6b790&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b6b790",
  null
  
)

export default component.exports